"use client";
import AntdStyleRegistry from "./AntdStyleRegistry";
import { ConfigProvider, App } from "antd";
import React from "react";
import theme from "@/constants/theme.json";
import { renderRequiredMark } from "@/lib/formUtils";
import LocationWrapper from "@/components/Wrappers/LocationWrapper";
import { LayoutProvider } from "./LayoutContext";

import ErrorBoundary from "@/app/(explore)/error";
import PageReadyGate from "@/components/PageReadyGate";

const ApplicationProvider = ({
  children,
  defaultLocation,
  defaultState,
  defaultCountry,
  defaultPincode,
  locationSelectorConfig,
}) => {
  return (
    <AntdStyleRegistry>
      <ConfigProvider
        theme={theme}
        form={{
          requiredMark: renderRequiredMark,
        }}
      >
        <App>
          <LayoutProvider>
            {/* No <Suspense> here. One used to wrap every page, which let the
                header/footer shell flush with a 200 before any route decided
                its status — so notFound() anywhere answered 200 and rendered
                the 404 page client-side, a soft 404 for every crawler.
                Streaming for CMS pages comes from the catch-all route's own
                loading.js, which sits below the segment layout that now
                decides the status (app/(explore)/[[...slug]]/layout.js). */}
            <ErrorBoundary>
              <LocationWrapper
                defaultLocation={defaultLocation}
                defaultState={defaultState}
                defaultCountry={defaultCountry}
                defaultPincode={defaultPincode}
                locationSelectorConfig={locationSelectorConfig}
              >
                <PageReadyGate>{children}</PageReadyGate>
              </LocationWrapper>
            </ErrorBoundary>
          </LayoutProvider>
        </App>
      </ConfigProvider>
    </AntdStyleRegistry>
  );
};

export default ApplicationProvider;
